import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';

// project import
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';

// ==============================|| DRAWER HEADER ||============================== //

const DrawerHeader = ({ open, setMenuSelected }) => {
  const theme = useTheme();

  return (
    <DrawerHeaderStyled theme={theme} open={open} sx={{}}>
      <Logo setMenuSelected={setMenuSelected} isIcon={!open} />
    </DrawerHeaderStyled>
  );
};

DrawerHeader.propTypes = {
  open: PropTypes.bool,
  setMenuSelected: PropTypes.func
};

export default DrawerHeader;
